import PropTypes from 'prop-types';
import './SlideRating.scss';

export const getProgress = (rating) => {
  if (!rating || typeof rating === 'string') return { width: 0 };

  const progress = (rating / 5) * 100;

  return {
    width: `${progress}%`,
  };
};

export const getStringRating = (rating) => {
  let ratingString = rating.toString();

  if (ratingString.length === 1) {
    ratingString += ',0';
  }

  if (ratingString.indexOf('.') > 0) {
    ratingString = ratingString.replace('.', ',');
  }

  return ratingString;
};

const SlideRating = ({ title, rating }) => {
  if (rating < 0 || rating > 5) {
    return null;
  }

  return (
    <div className="gw-slide-rating">
      {title && <div className="gw-slide-rating__label">{title}</div>}
      <div className="gw-slide-rating__bar-container">
        <div className="gw-slide-rating__bar">
          <div
            className="gw-slide-rating__progress"
            style={getProgress(rating)}
          />
        </div>
        <div className="gw-slide-rating__rating">
          {getStringRating(Math.round(rating * 10) / 10)}
        </div>
      </div>
    </div>
  );
};

SlideRating.propTypes = {
  title: PropTypes.string,
  rating: PropTypes.number.isRequired,
};

SlideRating.defaultProps = {
  title: null,
};

export default SlideRating;
